import { Link } from 'react-router-dom';

export default function Footer() {
  const logoUrl = 'https://media.base44.com/images/public/6a33f776ca9ab1423a01beaf/3117d87bb_clearmind_icon_white_background.png';

  return (
    <footer className="border-t border-background-200/70 py-10 bg-background-100">
      <div className="w-full px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <img
            src={logoUrl}
            alt="ClearMind Club"
            className="w-5 h-5 object-contain"
          />
          <span className="font-heading font-medium text-foreground-950">
            ClearMind Club
          </span>
        </div>
        <div className="flex gap-6 text-sm font-label">
          <Link
            to="/knowledge-hub"
            className="text-foreground-600 hover:text-foreground-950 transition-colors"
          >
            Knowledge Hub
          </Link>
          <Link
            to="/blog"
            className="text-foreground-600 hover:text-foreground-950 transition-colors"
          >
            Blog
          </Link>
          <Link
            to="/course"
            className="text-foreground-600 hover:text-foreground-950 transition-colors"
          >
            Course
          </Link>
          <Link
            to="/disclaimer"
            className="text-foreground-600 hover:text-foreground-950 transition-colors"
          >
            Disclaimer
          </Link>
          <Link
            to="/affiliate-disclosure"
            className="text-foreground-600 hover:text-foreground-950 transition-colors"
          >
            Affiliate Disclosure
          </Link>
          <Link
            to="/pricing"
            className="text-foreground-600 hover:text-foreground-950 transition-colors"
          >
            Pricing
          </Link>
        </div>
        <div className="flex items-center gap-4">
          <a
            href="https://www.facebook.com/clearmindclub"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="ClearMind Club on Facebook"
            title="ClearMind Club on Facebook"
            className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-900 hover:bg-secondary-500 hover:text-background-50 transition-colors cursor-pointer"
          >
            <i className="ri-facebook-fill text-base" />
          </a>
          <a
            href="https://www.instagram.com/clearmindc1ub"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="ClearMind Club on Instagram"
            title="ClearMind Club on Instagram"
            className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-900 hover:bg-secondary-500 hover:text-background-50 transition-colors cursor-pointer"
          >
            <i className="ri-instagram-line text-base" />
          </a>
          <p className="text-sm font-label text-foreground-500">
            &copy; 2026 ClearMind Club
          </p>
        </div>
      </div>
    </footer>
  );
}